export enum EnumTipoElemLog {
  TODOS = 0,
  PVB = 1,
  PR = 2,
  AASS = 3,
  PCPR = 4,
  PCDB = 5,
  PCCC = 6,
  PCAS = 7,
  PCI = 8,
  PCY = 9,
  PCTD = 10,
  PCDD = 11,
  PCLD = 12,
  PS = 13,
  PE = 14,
  RT = 15,
  RD = 16,
  PCLD_ME = 17,
  PSAT = 18,
  PITGNL = 20,
  PIAS = 21,
  PCRT = 22,
  Suprapunto = 23,
  Posicion = 24,
  PO = 25,
  Buque = 26,
  PF = 28,
  PCPF = 29,
  Infraestuctura = 30,
  Punto = 31,
  Otro = 32
}
